export enum SortButtonDirection {
  Asc = "asc",
  Desc = "desc",
}
